import { SentryConfig } from '../sentry/types';

export interface App {
  basePath: string;
  baseUrl: string;
  locale: 'cs' | 'de' | 'en' | 'hu' | 'ru' | 'sk';
  defaultLocale: 'cs';
  productBuilder: {
    rootId: string;
    configAttribute: string;
    modeAttribute: string;
  };
  productConfigurator: {
    rootId: string;
    configAttribute: string;
  };
  sentry: SentryConfig;
  urls: Record<string, string>;
}

interface Window {
  app?: App;
}

const { app } = window as Window;

if (!app) {
  throw new Error('Object window.app is missing!');
}

export const {
  basePath,
  baseUrl,
  locale,
  defaultLocale,
  productBuilder,
  productConfigurator,
  sentry,
  urls,
} = app;
